<ion-app swipe
  [attr.data-accent]="currentAccent()"
  (previous)="onSwipeBack()">
  <app-bootstrap-loading-overlay></app-bootstrap-loading-overlay>
  <app-shell></app-shell>
</ion-app>
